import React, { useState, useEffect } from 'react'
import Header from '../component/header';
import "../assets/css/profile.css";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import configModule from '../../config.js';
import { Toaster, toast } from "react-hot-toast";

function Profile() {
  const [usersData, setUsersData] = useState(null);
  const [profileData, setProfileData] = useState('');
  const config = configModule.config();

  const getDashboardData = async () => {

    try {
      const response = await axios.get(
        `${config.apiBaseUrl}/get-profiledetails/${usersData?.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data?.data[0];
      setProfileData(data);


    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";

      toast.error(message);
    }
  };

  useEffect(() => {
    if (usersData?.id) {
      getDashboardData();
    }
  }, [usersData]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const decoded = jwtDecode(token);
      setUsersData(decoded);
    }
  }, []);

  const formatReturnMonth = (date) => {
    if (!date) return "";
  
    return new Date(date).toLocaleString("en-US", {
      month: "short",
      year: "numeric",
      day: "numeric"
    });
  };

  return (
    <div className='dashboardmain-st'>
      <Header pageName="Documents" />
      <div className="body-dashboard">
        <div className="page-header">
          <div className="page-eyebrow">Account</div>
          <div className="page-title">My Profile</div>
          <div className="page-subtitle">Your registered information — read only. Contact Lexora to make changes.</div>
        </div>

        <div className='mainprofile-st'>
          <div>
            <div className="leftcontainer-stpro">
              <div className='namelogopro-st'>{profileData?.full_name
                        ?.trim()
                        ?.split(" ")
                        ?.map(word => word[0])
                        ?.join("")
                        ?.slice(0, 2)
                        ?.toUpperCase() || "?"}</div>
              <div className='nametextpro-st'>{profileData?.full_name || ''}</div>
              <div className='nameidpro-st'>{profileData?.investor_id || ''}</div>
              <div className='activeuserid-st'>
                <span className="pill pill-active">{profileData?.status || ''}</span>
              </div>
              <div className='namebodypro-st'>
                <div className="pf-label">Member Since</div>
                <div className="pf-value pf-value-st" >{profileData?.invesment_date ?  formatReturnMonth(profileData?.invesment_date) : ''}</div>
                <div className="pf-label pf-label-st" >Total Properties</div>
                <div className="pf-value pf-value-st" >Phase 1</div>
                <div className="pf-label pf-label-st" >Residential Status</div>
                <div className="pf-value pf-value-st" >{profileData?.residential_status || ''}</div>
              </div>
            </div>
          </div>

          <div>
            <div className="rgtcontainer-stpro">
              <div className="procard-header"><div className="procard-title">Personal Details</div></div>
              <div className="profile-cols marginprost">
                <div className="profile-field"><div className="pf-label">Full Name</div><div className="pf-value">{profileData?.full_name}</div></div>
                <div className="profile-field"><div className="pf-label">Father's / Spouse's Name</div><div className="pf-value">{profileData?.father_spouse_name}</div></div>
                <div className="profile-field"><div className="pf-label">Date of Birth</div><div className="pf-value">{profileData?.created_at ?  formatReturnMonth(profileData?.date_of_birth) : ''}</div></div>
                <div className="profile-field"><div className="pf-label">Gender</div><div className="pf-value">{profileData?.gender || ''}</div></div>
                <div className="profile-field"><div className="pf-label">Nationality</div><div className="pf-value">{profileData?.nationality || ''}</div></div>
                <div className="profile-field"><div className="pf-label">Occupation</div><div className="pf-value">{profileData?.occupation || ''}</div></div>
                <div className="profile-field"><div className="pf-label">Annual Income</div><div className="pf-value">{profileData?.income_range || ''}</div></div>
              </div>

              <div className="profile-section-label">
                <svg viewBox="0 0 24 24" strokeWidth="2"><path d="M22 16.9A5 5 0 0 1 17 22C9.27 22 3 15.73 3 8a5 5 0 0 1 5.1-5l1.27 5.35-2.1 2.1a14.9 14.9 0 0 0 6.28 6.28l2.1-2.1L20.65 15.9z"></path></svg>
                Contact Details
              </div>
              <div className="profile-cols">
                <div className="profile-field"><div className="pf-label">Mobile</div><div className="pf-value">{profileData?.mobile || ''}</div></div>
                <div className="profile-field"><div className="pf-label">Email</div><div className="pf-value">{profileData?.email || ''}</div></div>
                <div className="profile-field" ><div className="pf-label">Permanent Address</div><div className="pf-value">{profileData?.perm_address || ''}</div></div>
                <div className="profile-field"><div className="pf-label">City</div><div className="pf-value">{profileData?.city || ''}</div></div>
                <div className="profile-field"><div className="pf-label">PIN Code</div><div className="pf-value">{profileData?.pin || ''}</div></div>
              </div>

              <div className="profile-section-label">
                <svg viewBox="0 0 24 24" strokeWidth="2"><rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="M3 10h18M7 15h4M15 15h2"></path></svg>
                KYC Details
              </div>
              <div className="profile-cols">
                <div className="profile-field"><div className="pf-label">PAN Number</div><div className="pf-value pf-masked">{profileData?.pan || ''}</div></div>
                <div className="profile-field"><div className="pf-label">Aadhaar (Last 4)</div><div className="pf-value pf-masked">**** **** {profileData?.aadhaar_last4 || 'XXXX'}</div></div>
                <div className="profile-field"><div className="pf-label">Bank Account</div><div className="pf-value pf-masked">{profileData?.bank_account || ''}</div></div>
                <div className="profile-field"><div className="pf-label">IFSC</div><div className="pf-value">{profileData?.ifsc || ''}</div></div>
              </div>

              <div className="profile-section-label">
                <svg viewBox="0 0 24 24" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                Nominee Details
              </div>
              <div className="profile-cols">
                <div className="profile-field"><div className="pf-label">Nominee Name</div><div className="pf-value">{profileData?.nom_name || ''}</div></div>
                <div className="profile-field"><div className="pf-label">Relationship</div><div className="pf-value">{profileData?.nom_relationship || ''}</div></div>
                <div className="profile-field"><div className="pf-label">Nominee DOB</div><div className="pf-value">{profileData?.nom_dob ? formatReturnMonth(profileData?.nom_dob) : ''}</div></div>
                <div className="profile-field"><div className="pf-label">Nominee Contact</div><div className="pf-value">{profileData?.nom_phone || ''}</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#0a1628",
            color: "#fff",
            borderRadius: "10px",
            padding: "14px 18px",
          },
          success: {
            iconTheme: {
              primary: "#22c55e",
              secondary: "#fff",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />
    </div>
  )
}

export default Profile;
